import React, { useEffect, useRef } from 'react';
import ShowAttachmentsProperties from "./ShowAttachmentsProperties";
import { useStyles } from "./ShowAttachments.style";
import clsx from "clsx";
import ProductOrderAttachmentResponse from '../../../model/productOrder/ProductOrderAttachmentResponse';
import ShowImage from '../ShowImage/ShowImage';
import ProductOrderAttachmentType from '../../../model/productOrder/ProductOrderAttachmentType';
import ShowDate from '../ShowDate/ShowDate';

const ShowAttachments: React.FC<ShowAttachmentsProperties> = ({
    attachments = [],
    className = '',
}) => {

    const classes = useStyles();
    const divRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (divRef.current) {
            setTimeout(() => {
                if (divRef.current) {
                    divRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
                }
            }, 100);
        }
    }, []);

    const getAttachmentTypeLabel = (type: ProductOrderAttachmentType): string => {
        switch (type) {
            case ProductOrderAttachmentType.DELIVERY_EVIDENCE:
                return 'Evidencia de Entrega';
            case ProductOrderAttachmentType.DELIVERY_ISSUE:
                return 'Problema con la Entrega';
            default:
                return 'Outro';
        }
    };

    const getAttachmentTypeClass = (type: ProductOrderAttachmentType): string => {
        switch (type) {
            case ProductOrderAttachmentType.DELIVERY_ISSUE:
                return classes.type_badge_issue;
            case ProductOrderAttachmentType.DELIVERY_EVIDENCE:
                return classes.type_badge_evidence;
            default:
                return classes.type_badge_default;
        }
    };

    return (
        <div className={clsx(classes.show_attachments_container, className, attachments.length === 0 && classes.empty)}>
            <div className={classes.attachments_container}>
                {attachments && attachments.length > 0 ? (
                    <div className={classes.attachments_grid}>
                        {attachments.map((attachment: ProductOrderAttachmentResponse) => (
                            <div key={attachment.id} className={classes.attachment_item}>
                                <div className={classes.image_wrapper}>
                                    <ShowImage 
                                        imageName={`product-order/${attachment.image}`} 
                                        width={70} 
                                        height={70}
                                    />
                                </div>
                                <div className={classes.attachment_info}>
                                    <div className={classes.attachment_type}>
                                        <span className={clsx(classes.type_badge, getAttachmentTypeClass(attachment.type))}>
                                            {getAttachmentTypeLabel(attachment.type)}
                                        </span>
                                    </div>
                                    {attachment.description && (
                                        <div className={classes.attachment_description}>
                                            <span className={classes.label}>Descripción:</span>
                                            <span className={classes.value}>{attachment.description}</span>
                                        </div>
                                    )}
                                    <div className={classes.attachment_date}>
                                        <span className={classes.value}>
                                            <ShowDate timestamp={attachment.createdAt}/>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <span className={classes.no_attachments}>Ningún anexo disponible para este pedido</span>
                )}
                <div ref={divRef} />
            </div>
        </div>
    )
}

export default ShowAttachments;
